import { ReactNode } from "react";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { ChatBubble, ScheduleButton } from "@/components/chat/ChatBubble";
import { MaintenanceChecklistPopup } from "@/components/home/MaintenanceChecklistPopup";

export function SiteShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <div className="flex-1">{children}</div>
      <Footer />
      <ChatBubble />
      <ScheduleButton />
      <MaintenanceChecklistPopup />
    </div>
  );
}
